import { Scene } from "phaser";
import { GAMEVARS, SCENES } from "../constants";
import { BaseScene } from "./basescene";
import { SaveData } from "./savedata";

export class Boot extends BaseScene {
    constructor() {
        super(SCENES.BOOT);
    }

    preload() {
        //Load preloader assets here..
    }

    async create() {


        GAMEVARS.gameWidth = Number(this.game.config.width);
        GAMEVARS.gameHeight = Number(this.game.config.height);


        const c = await import('./preloader');
        this.scene.add(SCENES.PRELOADER, c.Preloader, false);
        this.scene.start(SCENES.PRELOADER);
    }

    pauseGame(): void {

    }
    resumeGame(): void {

    }
}